import React from 'react';

import ReactMapboxGl, { GeoJSONLayer } from 'react-mapbox-gl';

class PrintMiniMap extends React.Component {
    constructor (props) {
        super(props);

        this.map = null;
        this.MapboxComponent = ReactMapboxGl({
            accessToken: process.env.MAPBOX_ACCESS_TOKEN,
            minZoom: 2,
            maxZoom: 22,
            preserveDrawingBuffer: true,
            fadeDuration: 0
        });

        this.handleStyleLoaded = this.handleStyleLoaded.bind(this);
        this.handleMapIdle = this.handleMapIdle.bind(this);
    }

    handleStyleLoaded (map) {
        this.map = map;
        this.map.on('idle', this.handleMapIdle);
    }

    handleMapIdle (event) {
        this.props.onImageReady(this.map.getCanvas().toDataURL('image/png', 1.0));
    }

    render () {
        const { style, width, height, fitBounds } = this.props;

        const Map = this.MapboxComponent;

        return (
            <div style={{
                width: width,
                height: height,
                position: 'absolute'
            }}>
                <Map
                    style={style}
                    onStyleLoad={this.handleStyleLoaded}
                    fitBounds={fitBounds}
                    fitBoundsOptions={{
                        padding: 125,
                        pitch: 0,
                        bearing: 0
                    }}
                >
                    <GeoJSONLayer
                        data={{
                            'type': 'Polygon',
                            'coordinates': [[
                                [fitBounds[0][0], fitBounds[0][1]],
                                [fitBounds[0][0], fitBounds[1][1]],
                                [fitBounds[1][0], fitBounds[1][1]],
                                [fitBounds[1][0], fitBounds[0][1]],
                                [fitBounds[0][0], fitBounds[0][1]]
                            ]]
                        }}
                        fillPaint={{
                            'fill-color': 'transparent',
                            'fill-opacity': 1.0
                        }}
                        linePaint={{
                            'line-width': 2,
                            'line-color': '#1B3134'
                        }}
                    />
                </Map>
            </div>
        );
    }
}

export default PrintMiniMap;